jQuery(document).ready(function($) {
    $('textarea[name="your-message"]').attr('rows', 5);
});